module.exports = __webpack_public_path__ + "static/media/ts.3aeee229.svg";